<template>
  <div class="row user-data">
    <div class="col">
      <!-- Vue Router Link -->
      <router-link
        v-if="link && isRouterLink"
        :to="link"
        class="link-style normal"
        :class="{'inactive-link': !amount}"
      >
        <div class="card text-dark mb-3 info-card">
          <div class="position-relative">
            <div v-if="time" class="position-absolute end-0 time-rectangle">
              <div class="metric-style small bold">{{time}}</div>
            </div>
          </div>
          <div class="card-body">
            <div class="text-center inside-card">
              <div class="amount number-value-style" :style="`color: ${color}`"><ins>{{amount}}</ins></div>
              <div class="metric-style black">{{subtitle}}</div>
            </div>
          </div>
        </div>
      </router-link>

      <!-- Legacy External Link -->
      <a
        v-else-if="link && !isRouterLink"
        target="_blank"
        :href="link"
        class="link-style normal"
        :class="{'inactive-link': !amount}"
      >
        <div class="card text-dark mb-3 info-card">
          <div class="position-relative">
            <div v-if="time" class="position-absolute end-0 time-rectangle">
              <div class="metric-style small bold">{{time}}</div>
            </div>
          </div>
          <div class="card-body">
            <div class="text-center inside-card">
              <div class="amount number-value-style" :style="`color: ${color}`"><ins>{{amount}}</ins></div>
              <div class="metric-style black">{{subtitle}}</div>
            </div>
          </div>
        </div>
      </a>

      <!-- Report Download Link -->
      <a
        v-else-if="reportConfig"
        href="#"
        class="link-style normal"
        :class="{'inactive-link': !amount}"
        @click.prevent="$emit('download-report', reportConfig)"
      >
        <div class="card text-dark mb-3 info-card">
          <div class="position-relative">
            <div v-if="time" class="position-absolute end-0 time-rectangle">
              <div class="metric-style small bold">{{time}}</div>
            </div>
          </div>
          <div class="card-body">
            <div class="text-center inside-card">
              <div class="amount number-value-style" :style="`color: ${color}`"><ins>{{amount}}</ins></div>
              <div class="metric-style black">{{subtitle}}</div>
            </div>
          </div>
        </div>
      </a>

      <!-- No Link -->
      <div v-if="!link && !reportConfig" class="card text-dark mb-3 info-card" :class="{'h-100': isHeightFull}">
        <div class="position-relative">
          <div v-if="time" class="position-absolute end-0 time-rectangle">
            <div class="metric-style small bold">{{time}}</div>
          </div>
        </div>
        <div class="card-body" :class="{'d-flex justify-content-center align-items-center': isHeightFull}">
          <div class="text-center inside-card">
            <div class="amount number-value-style" :style="`color: ${color}`"><ins>{{amount}}</ins></div>
            <div class="metric-style black">{{subtitle}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserInfo',
  props: {
    subtitle: {
      type: String,
      required: true,
    },
    amount: {
      type: Number,
      required: true,
    },
    time: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: '#363647',
    },
    link: {
      type: [String, Object],
      default: null,
      validator(value) {
        if (value === null) return true;
        if (typeof value === 'string') return true;
        if (typeof value === 'object') {
          // Vue router object should have name or path
          return value.name || value.path;
        }
        return false;
      },
    },
    reportConfig: {
      type: Object,
      default: null,
      validator(value) {
        if (value === null) return true;
        // Report config should have reportType and optional params
        return value.reportType && typeof value.reportType === 'string';
      },
    },
    isHeightFull: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    // check if link is a router link instead of old external link which was a string
    isRouterLink() {
      return this.link && typeof this.link === 'object';
    },
  },
  mounted() {
    if (this.amount === undefined) console.log(this.subtitle);
  },
};
</script>

<style>

</style>
